import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GetRolesForApplicationDto,
  RoleDto,
  RoleManagementPreload,
} from '@clearing-hub/common';
import {
  CreateRoleCommand,
  FindRolesCommand,
  UpdateRoleCommand,
} from '@clearing-hub/command';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private readonly http: HttpClient) {}

  preload(): Observable<RoleManagementPreload> {
    return this.http.get<RoleManagementPreload>('/adm/api/role');
  }

  findRoles(command: FindRolesCommand): Observable<GetRolesForApplicationDto> {
    return this.http.post<GetRolesForApplicationDto>('/adm/api/role', command);
  }

  updateRole(r: UpdateRoleCommand): Observable<void> {
    return this.http.patch<void>('/adm/api/role', r);
  }

  createRole(r: CreateRoleCommand): Observable<RoleDto> {
    return this.http.put<RoleDto>('/adm/api/role', r);
  }

  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>('/adm/api/role', { body: { id } });
  }
}
